import { useEffect, useRef } from "react";

import { UseInfiniteScrollParams } from "./types";
import { OBSERVER_OPTIONS } from "./constants";

export const useInfiniteScroll = <T extends HTMLElement>({
  shouldLoad,
  isLoading,
  loadData,
}: UseInfiniteScrollParams) => {
  const loadTriggerRef = useRef<T>(null);

  useEffect(() => {
    if (!shouldLoad || isLoading) {
      return;
    }

    const { current: loadTrigger } = loadTriggerRef;

    const observer: IntersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          return;
        }

        loadData();
      });
    }, OBSERVER_OPTIONS);

    if (!loadTrigger) {
      return;
    }

    observer.observe(loadTrigger);

    return () => {
      observer.disconnect();
    };
  }, [shouldLoad, isLoading, loadData]);

  return {
    loadTriggerRef,
  };
};
